import { Auth } from 'aws-amplify';
import { useState } from 'react';
import { loggerInfo } from 'utils/infoLog';
import { useToast } from '@welbe/web-design-system';

export const useChangePassword = (onClose: () => void) => {
	const { toast } = useToast();
	const [isLoading, setLoading] = useState(false);
	const [isCurrentPasswordError, setCurrentPasswordError] = useState(false);
	const [confirmPassword, setConfirmPassword] = useState('');
	const [isConfirmPasswordError, setConfirmPasswordError] = useState(false);
	const [isRegexError, setRegexError] = useState(false);
	const [hasError, setError] = useState(false);
	const [errorMessage, setErrorMessage] = useState('');
	const [userPasswords, setUserPasswords] = useState({
		newPassword: '',
		oldPassword: '',
	});

	const handleToast = (error: boolean) => {
		if (error) {
			toast.error('Error al cambiar la contraseña, intente nuevamente');
			return;
		}

		toast.success('Contraseña cambiada con éxito');
	};

	const checkValidRegex = () => {
		const regEx =
			// eslint-disable-next-line no-useless-escape
			/^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~`!@#$%^&*()--+={}\[\]|\\:;"'<>,.?/_]).{8,}$/;
		if (!regEx.test(userPasswords.newPassword)) {
			return false;
		}

		return true;
	};

	const resetErrors = async () => {
		setErrorMessage('');
		setRegexError(false);
		setConfirmPasswordError(false);
		setError(false);
	};

	const checkFields = () => {
		if (
			!userPasswords.newPassword ||
			!userPasswords.oldPassword ||
			!confirmPassword
		) {
			setError(true);
			setErrorMessage('Todos los campos son obligatorios');
			return false;
		}

		if (!userPasswords.oldPassword) {
			setErrorMessage('La contraseña actual es requerida');
			setCurrentPasswordError(true);
			return false;
		}

		if (userPasswords.newPassword !== confirmPassword) {
			setConfirmPasswordError(true);
			setErrorMessage('Las contraseñas no coinciden');
			return false;
		}

		if (!checkValidRegex()) {
			setRegexError(true);
			setErrorMessage(
				`La contraseña debe tener al menos 8 caracteres, una letra mayúscula, una minúscula, un número y un caracter especial. Caracteres disponibles ^ $ * . [ ] { } ( ) ? " ! @ # % & / ${'\\ ,'} > < ${"'"} ${': ;'} | _ ~ ${'`'} = + - `,
			);
			return false;
		}

		return true;
	};

	const handleSubmit = async () => {
		await resetErrors();
		if (checkFields()) {
			let hasError = false;
			setLoading(true);
			try {
				const user = await Auth.currentAuthenticatedUser();
				await Auth.changePassword(
					user,
					userPasswords.oldPassword,
					userPasswords.newPassword,
				);
				onClose();
			} catch (error) {
				hasError = true;
				loggerInfo({
					data: error,
					context: 'login',
					location: 'changePassword',
				});
			} finally {
				handleToast(hasError);
				setLoading(false);
			}
		} else {
			console.error('Invalid fields');
		}
	};
	return {
		isCurrentPasswordError,
		isRegexError,
		errorMessage,
		hasError,
		isConfirmPasswordError,
		userPasswords,
		isLoading,
		setConfirmPassword,
		setUserPasswords,
		handleSubmit,
	};
};
